import fetch from "isomorphic-fetch"
import { pendingTask, begin, end } from "react-redux-spinner"
import {
  GET_NOTIFICATION_REQUEST,
  GET_NOTIFICATION,
  GET_NOTIFICATION_ERROR
} from "./types"

export function getNotificationRequest() {
  console.log("get notification request")
  const data = {
    loading: true
  }
  return {
    type: GET_NOTIFICATION_REQUEST,
    [pendingTask]: begin,
    payload: data
  }
}

export function getNotificationSuccess(notification) {
  console.log("notification: " + JSON.stringify(notification))
  const data = {
    loading: false,
    notification
  }
  return {
    type: GET_NOTIFICATION,
    [pendingTask]: end,
    payload: data
  }
}

export function getNotificationFail(error) {
  const data = {
    loading: false,
    error
  }
  return {
    type: GET_NOTIFICATION_ERROR,
    [pendingTask]: end,
    payload: data
  }
}

export function getNotification(id) {
  console.log("GET A notification WITH ID: " + id)
  return dispatch => {
    dispatch(getNotificationRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/notifications/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(json => {
        //console.error('getNotification: ' + JSON.stringify(json.notification))
        dispatch(getNotificationSuccess(json))
      })
      .catch(error => dispatch(getNotificationFail(error)))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/notification_show.js
 **/